module.exports = __webpack_public_path__ + "assets/b64.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b64.png
// module id = 654
// module chunks = 0